<template>
        <div class="employeevalidatedate">
        <PageTitle
            icon="fa fa-clone"
            main="Documento"
            sub="Funcionário"
        />
          <b-card bg-variant="light" text-variant="dark" sub-title="Documento(s) - Data de Validade">
            <b-row>
                <b-col md="3" sm="6">
                    <b-table
                        class="table-responsive"
                        :select-mode="selectMode"
                            @row-selected="onRowEmployeeSelected"
                            selectable
                        :items="company_employees"
                        :fields="fieldsEmployee"
                        >
                        <template #cell(selected)="{ rowSelected }">
                            <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selecionado</span>
                            </template>
                            <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Não Selecionado</span>
                            </template>
                        </template>
                          <template v-slot:cell(actions)="data">
                                <b-button
                                    title="Solicitar Autorização"
                                    size="sm"
                                    variant="info"
                                    @click="changeFile(data.item)"
                                    :disabled="request_accept"
                                    class=" mr-2"
                                >

                                    <div  class="d-flex justify-content-center ">
                                    <b-spinner v-show="request_accept" label="Enviando..."></b-spinner>
                                </div>
                                <div v-show="!request_accept">
                                        <i  v-show="!request_accept" class="fa fa-exchange"></i>
                                        Solicitar Autorização
                                    </div>
                            </b-button>
                        </template>
                    </b-table>
                    </b-col>
                   <b-col md="9" sm="12">
                             <b-table
                                        class="table-responsive"
                                        hover
                                        head-variant="ligth"
                                        :items="employees_files"
                                        :fields="fieldsFile"
                                    >
                                    <template v-slot:cell(actions)="data">
                                            <b-button
                                                title="Visualizar"
                                                size="sm"
                                                variant="outline-dark"
                                                @click="
                                                    ;[
                                                        loadFile(data.item),
                                                        openModalPDF()
                                                    ]
                                                "
                                                class="mr-2 mt-2"
                                            >
                                                <i class="fa fa-file-pdf-o"></i>
                                                Visualizar
                                            </b-button>
                                            
                                            
                                    </template>
                                     <template v-slot:cell(actions1)="data">
                                        <b-button
                                                title="Editar Arquivo"
                                                size="sm"
                                                variant="outline-dark"
                                                @click="[loadFile(data.item),openModalFile()]"
                                                class="mr-2 mt-2"
                                            >
                                                <i class="fa fa-pencil"></i>
                                                Editar
                                            </b-button>
                                    </template>
                                  
                             </b-table>
                          </b-col>
            </b-row>
          </b-card>
          <b-modal
                    id="modalPDF"
                    ref="modal"
                    title-tag="h6"
                    centered
                    size="lg"
                    ok-only
                    title="Visualização do Documento"
                >
                    <div>
                        <pdf :src="employees_file.url_file"></pdf>
                    </div>
        </b-modal>
         <b-modal
             v-model="modalFileShow"
            id="modalFile"
            title-tag="h6"
            centered
            size="lg"
            title="Arquivo"
        >
        <b-row >
                  <b-col md="3" sm="12">
                    <b-form-group
                        label="Data de Validade:"
                        label-for="employees_file-validade_date_changed_validate"
                        >
                        <b-form-input
                            id="employees_file-validade_date_changed_validate"
                            type="date"
                            v-model="employees_file.validade_date_changed_validate"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row >
                <b-col md="5" sm="12">
                    <b-form-file
                        accept=".pdf"
                        v-model="file"
                        class="mt-4 mb-4"
                        plain
                        @input="saveImagem"
                        :disabled="file_doc_show"
                        size="sm"
                    ></b-form-file>
                </b-col>
            </b-row>
              <b-row v-show="!employees_file.has_date">
                <b-col md="5" sm="12">
                    <b-form-file
                        accept=".pdf"
                        v-model="file"
                        class="mt-4 mb-4"
                        plain
                        @input="saveImagem"
                        :disabled="file_doc_show"
                        size="sm"
                    ></b-form-file>
                </b-col>
              </b-row>
            <template #modal-footer>
                    <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        v-show="!file_upload_show"
                        class="float-right"
                        @click="modalFileShow=false"
                    >
                        Fechar
                    </b-button>
                    <b-button variant="primary" disabled  v-show="file_upload_show">
                        <b-spinner small type="grow"></b-spinner>
                        Carregando...
                    </b-button>
                    </div>
                </template>
        </b-modal>
        </div>
</template>
<script>

import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import pdf from 'vue-pdf'

var moment = require('moment-timezone')

export default {
    name: 'EmployeeValidateDate',
   components: { PageTitle,pdf},
    data: function(){
        return{
            selectMode: 'single',
            selected: [],
            employees_files: [],
            employees_file: {},
            company_employees:[],
            selectedEmployee: [],
            company_employee: {},
            file_upload_show: false,
            request_accept:false,
            file: null,

            fieldsFile: [
               
                {
                    key: 'name_type_document',
                    label: 'Documento',
                     variant: 'light',
                    sortable: true
                },
                {
                    key: 'justify_comments_validate',
                    label: 'Justificativa',
                     variant: 'light',
                    sortable: false
                },  
                 {
                    key: 'validade_date_validate',
                    label: 'Validade',
                     variant: 'light',
                    sortable: false
                },  
                {
                    key: 'validade_date_changed_validate',
                    label: 'Validade Alterada',
                      formatter: value =>
                                value ? moment.utc(value).format('DD-MM-YYYY') : '',
                     variant: 'light',
                    sortable: false
                },        
                {
                    key: 'changed_validate',
                    label: 'Alterado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                { key: 'actions', label: '', variant: 'light' },
                { key: 'actions1', label: '', variant: 'light' },
               
                ],
                fieldsEmployee: [
                {
                    key:'selected',
                    label:'...'
                },
                {
                    key: 'name_employee',
                    label: 'Nome Funcionário',
                    sortable: false
                },
                { key: 'actions', label: '', variant: 'light' },
                ],
        }
    },
    computed: {
        compan() {
            return this.$store.state.compan
        },
        user() {
            return this.$store.state.user
        }
    },
    methods: {
         showMsgBoxSendFile(item) {
                this.boxCancel = ''
                this.$bvModal
                .msgBoxConfirm('Deseja enviar o arquivo ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        this.file_upload_table = true    
                        await this.checkFileFtp(item)
        
                    }
                })
            },
             openModalPDF() {
                this.$bvModal.show('modalPDF')
            },
            openModalFile() {
                this.file_doc_show = false
                this.$bvModal.show('modalFile')
            },
            closeModalFile(){
                this.$bvModal.hide('modalFile')
            },
            loadFile(item) {
                this.employees_file = { ...item,validade_date:null }
            },
            async  loadEmployeeFileRejects() {
            const url = `${baseApiUrl}/cpffilerejectuservalidatedates/${this.user.id}/?cpf_validate=${this.company_employee.cpf_employee}`
            await  axios(url).then(res => {
                    this.employees_files = res.data
                })
            },
            async  loadEmployeeRejects() {
            const url = `${baseApiUrl}/employeesvalidatedates/${this.user.id}`
            await  axios(url).then(res => {
                    this.company_employees = res.data
                })
            },
            async saveImagem() {

            this.file_upload_show = true
            let formData = new FormData()
            formData.append('file', this.file)
            formData.append('user_id_unique', this.user.id)
            formData.append('type_document_id_storage', this.employees_file.type_document_id_validate)

            await axios
                .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then( async () => {
                    this.$toasted.global.defaultSuccess()
                     await  this.getLastStorageFile()
                    this.type_doc_show =true
                })
                .finally(async ()=>{
                    if(this.employees_file.storage_file_id_validate > 0){
                      await  this.saveFile()
                    }else{
                          this.$toasted.global.defaultWarning({
                                msg: "Nâo foi possivel gravar o arquivo!Tente novamente....",
                                });
                    }
                })
                .catch(showError)
            },
            async getLastStorageFile() {
            const url = `${baseApiUrl}/storagefilesemployeevalidatebylast/?name_file=${this.file.name}&user_id_unique=${this.user.id}&type_document_id_storage=${this.employees_file.type_document_id_validate}`
            await axios(url).then(
                res =>
                    (this.employees_file = {
                        ...this.employees_file,
                        storage_file_id_validate: res.data.id,
                        name_file_validate: res.data.name_file,
                        path_file_validate: res.data.path_file,
                        changed_validate: 1,
                        id: this.employees_file.id,
                        type_document_id_validate: this.employees_file
                            .type_document_id_validate
                    })
            )
        },
        async saveFile() {
           
            const method = this.employees_file.id ? 'put' : 'post'
            const id = this.employees_file.id
                ? `/${this.employees_file.id}`
                : ''
            await axios[method](
                `${baseApiUrl}/employeesfilesvalidatedates${id}`,
                this.employees_file
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()  
                })
                .finally(async ()=>{
                   await this.checkFileFtp(this.employees_file)
                     this.closeModalFile()
                })
                .catch(showError)
        },
          async changeFile() {           

             this.request_accept = true

                await axios['post'](
               `${baseApiUrl}/employeesfileschangevalidatedate/${this.user.id}/?return_preview_code_validate=${this.company_employee.return_preview_code_validate}`
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()    
                     this.request_accept = false
                      this.loadEmployeeFileRejects()
                })
                .catch(showError)
                this.request_accept = false
        },
          async checkFileFtp(item) {

            this.employees_file = {...item}

            if(this.employees_file.storage_file_id_validate > 0){
                  await axios['put'](
                `${baseApiUrl}/employeesfilesftpvalidatedate/${this.employees_file.id}`,
                this.employees_file
            )
                .then(async() => {
                    this.$toasted.global.defaultSuccess()
                     await  this.loadEmployeeFileRejects()
                       this.file_upload_show = false
                })
                .finally( () => {
                     this.file_upload_table = false   
                     this.file_upload_show = false
                   
                })
                .catch(showError)
            }else{
                this.$toasted.global.defaultWarning({
                    msg: "Não existe arquivo anexo para envio!Favor verificar..",
                    });
            }                   
        },
        onRowEmployeeSelected(items) {
            this.company_employee ={}
            this.selectedEmployee = items
            let row = this.selectedEmployee[0]
            this.company_employee = row
                row ? this.loadEmployeeFileRejects(row) : this.employees_files = []    
        },
    },
    async mounted() {
        await this.loadEmployeeRejects()
    //    await  this.loadEmployeeFileRejects()
        this.employees_files = []
     }
}
</script>
<style>
    .employeevalidatedate {
        font-size: 0.75rem;
    }

    .employeevalidatedate button {
    font-size: 0.75rem;
    }

    #modalFile {
        font-size: 0.75rem;
    }

    #modalFile input {
        font-size: 0.75rem;
    }

    #modalFile button{
        font-size: 0.75rem;
    }

</style>